interface ParsedFile {
  /** original trimmed name */
  filename: string;
  name: string;
  extension?: string;
}
export const parseFileName = (_filename: string): ParsedFile => {
  const filename = _filename.trim();

  const parsed: ParsedFile = {
    filename,
    name: filename,
    extension: undefined,
  };

  const dotIndex = filename.lastIndexOf('.');
  if (dotIndex < 0) return parsed;

  parsed.name = filename.slice(0, dotIndex);
  parsed.extension = filename.slice(dotIndex + 1);

  return parsed;
};

export const isImageRegExp = new RegExp(
  `^.*(jpeg|Jpeg|jpg|JPG|gif|png|PNG|tiff|TIFF)$`
);
export const isPDFRegExp = new RegExp(`^.*(pdf|PDF)$`);
// export  const isOfficeFileRegExp = new RegExp(`^.*(doc|DOC|docx|DOCX|xls|XLS|xlsx|XLSX)$`);
